import React from 'react';
import { Form, Input, Button, Select, Spin, Card, Result, message, Table, Alert } from 'antd';
import axios from 'axios';
import moment from 'moment';
import * as serverconfig from '../serverconn';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { getTemplateConfig } from '../dataUploadTemplates';
import { downloadUploadTemplate, parseUploadFile } from '../dataUploadUtils';

var CryptoJS = require('crypto-js');

const FormItem = Form.Item;
const dateFormat = 'DD/MM/YYYY';
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token = '';
var sacco = '';
var username = '';

class DataUploadForm_LoanOpeningBal extends React.Component {
  state = {
    date: moment().format(dateFormat).toString(),
    datalist: [],
    uploadtype: 'loanopeningbalances',
    columns: [],
    message: '',
    companyprofile: {},
    datarequested: false,
    datasubmittedsuccessfully: false,
  };

  componentDidMount() {
    if (localStorage.getItem('sacco')) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
      username = CryptoJS.AES.decrypt(localStorage.getItem('username'), 'my-secret-key@123').toString(CryptoJS.enc.Utf8);
    } else {
      sacco = '';
      username = '';
    }

    token = localStorage.getItem('token') || '';

    axios.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    };

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`).then((res) => {
      this.setState({
        companyprofile: res.data,
        datarequested: false,
      });
    });
  }

  handleDownloadTemplate = () => {
    downloadUploadTemplate('loanopeningbalances');
    message.success('Template downloaded.');
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return;
    }

    this.setState({ datarequested: true, datalist: [], columns: [] });

    parseUploadFile(selectedFile, 'loanopeningbalances')
      .then((result) => {
        if (!result.ok) {
          message.error(result.error);
          this.setState({ datarequested: false });
          return;
        }

        this.setState({
          datalist: result.datalist,
          columns: result.columns,
          datarequested: false,
        });
      })
      .catch((err) => {
        message.error(err.message || 'Failed to process the uploaded file.');
        this.setState({ datarequested: false });
      });
  };

  handleFormSubmit = () => {
    if (this.state.datalist.length <= 0) {
      message.error('Datalist cannot be empty.');
      return;
    }

    this.setState({ datarequested: true });

    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('datalist', JSON.stringify(this.state.datalist));
    form_data.append('username', username);
    form_data.append('uploadtype', this.state.uploadtype);

    axios
      .post(`${serverconfig.backendserverurl}/customqueries/final_dataupload`, form_data, {
        headers: { 'content-type': 'multipart/form-data' },
      })
      .then((res) => {
        this.setState({
          message: res.data.message,
          datarequested: false,
          datasubmittedsuccessfully: true,
        });
      })
      .catch(() => {
        message.error('Upload failed. Please try again.');
        this.setState({ datarequested: false });
      });
  };

  render() {
    if (this.state.datarequested === true) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin indicator={antIcon} />
        </div>
      );
    }

    if (this.state.datasubmittedsuccessfully === true) {
      return (
        <Card>
          <Result
            status="success"
            title="Successful"
            subTitle={this.state.message}
            extra={[
              <Button type="primary" key="finish" onClick={() => window.location.reload(false)}>
                Finish
              </Button>,
            ]}
          />
        </Card>
      );
    }

    const templateConfig = getTemplateConfig('loanopeningbalances');

    return (
      <div>
        <h3>Loan opening balances upload</h3>
        <Alert
          type="warning"
          showIcon
          message="Do not change Excel column headings. openingBal_Date format: 01 Jan 2024."
          style={{ marginBottom: 16 }}
        />
        <Card>
          <Form layout="vertical">
            {templateConfig && (
              <Alert type="info" showIcon message={templateConfig.hint} style={{ marginBottom: 16 }} />
            )}
            <FormItem label="Template">
              <Button icon={<DownloadOutlined />} onClick={this.handleDownloadTemplate}>
                Download Excel template
              </Button>
            </FormItem>
            <FormItem label="Excel data file">
              <Input type="file" accept=".xlsx,.xls" onChange={this.handleFileChange} />
            </FormItem>
          </Form>
        </Card>

        <br />
        {this.state.datalist.length > 0 && (
          <div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
              <h2 style={{ margin: 0 }}>Processed Data ({this.state.datalist.length} rows)</h2>
              &nbsp;&nbsp;
              <Button type="primary" onClick={this.handleFormSubmit}>
                Upload data
              </Button>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <Table
                dataSource={this.state.datalist}
                columns={this.state.columns}
                scroll={{ x: 1000 }}
                bordered
                pagination={{ showQuickJumper: true, showSizeChanger: true }}
                size="small"
                rowKey={(record, index) => String(index)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DataUploadForm_LoanOpeningBal;
